module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1530-e1b5170866863bbfeed605a016571305.png";